import { render, staticRenderFns } from "./IconMakeAppointment.vue?vue&type=template&id=0493cc1d&"
import script from "./IconMakeAppointment.vue?vue&type=script&lang=ts&"
export * from "./IconMakeAppointment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports